// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions_by_id_title_component {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.transactions_box{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.payment-container {
  display: flex;
  flex-direction: column;
  max-width: 900px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  border-radius: 5px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.update-info,
.client-info,
.payment-method,
.risk-assessment,
.overtime-data {
  width: 20%;
}

.avatar {
  width: 40px;
  height: 40px;
  background-color: #b5b5b5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  color: white;
}

.client-info {
  display: flex;
  align-items: center;
}

.details-section {
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
}

.details-section p {
  margin-bottom: 10px;
}

.transactions_by_id_header{
  display: flex;
  justify-content: start;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
}

.transactions_by_id_header_profilPic{
  width: 80px;
  height: 80px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 200px;
}

.transactions_by_id_header_name{
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.transactions_by_id_header_name h3{
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.transactions_by_id_header_name span{
  margin: 0;
  font-size: 23px;
  font-weight: bold;
}

.transactions_by_id_items{
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 25px;
  width: max-content;
  background-color: #F2F3FC;
  padding: 0 25px;
  border-radius: 12px;
}

.transactions_by_id_items hr{
  margin: 0;
  border: solid 0.5px #c1c1c1;
}

.transactions_by_id_item_box{
  display: flex;
  flex-direction: column;
  padding: 25px 0;
}

.transactions_by_id_item_title{
  font-size: 14px;
  font-weight: 600;
  color: #2b2b2b;
  margin-bottom: 5px;
}

.transactions_by_id_item_content{
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

.withdrawDeposit_box{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.transactions_by_id_details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.transactions_by_id_details_wallet {
  width: 65%;
  display: flex;
  flex-direction: column;
  background-color: #F2F3FC;
  padding: 20px;
  border-radius: 15px;
}

.transactions_by_id_details_wallet_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.transactions_by_id_details_title {
  margin: 0 0 20px 0;
  font-size: 22px;
  font-weight: bold;
}

.transactions_by_id_details_box{
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.transactions_by_id_details_p {
  margin: 5px 0;
}

.transactions_by_id_details_item_title {
  margin: 0;
  font-size: 11px;
  display: block;
  color: #7f7f7f;
}

.transactions_by_id_details_item_desc{
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #5c5c5c;
}
`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/Transactions/TransactionById/transactionById.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".transactions_by_id_title_component {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.transactions_box{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.payment-container {\n  display: flex;\n  flex-direction: column;\n  max-width: 900px;\n  border: 1px solid #e0e0e0;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.header-section {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.update-info,\n.client-info,\n.payment-method,\n.risk-assessment,\n.overtime-data {\n  width: 20%;\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  background-color: #b5b5b5;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 10px;\n  color: white;\n}\n\n.client-info {\n  display: flex;\n  align-items: center;\n}\n\n.details-section {\n  border-top: 1px solid #e0e0e0;\n  padding-top: 20px;\n}\n\n.details-section p {\n  margin-bottom: 10px;\n}\n\n.transactions_by_id_header{\n  display: flex;\n  justify-content: start;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.transactions_by_id_header_profilPic{\n  width: 80px;\n  height: 80px;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  border-radius: 200px;\n}\n\n.transactions_by_id_header_name{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.transactions_by_id_header_name h3{\n  margin: 0;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.transactions_by_id_header_name span{\n  margin: 0;\n  font-size: 23px;\n  font-weight: bold;\n}\n\n.transactions_by_id_items{\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  gap: 25px;\n  width: max-content;\n  background-color: #F2F3FC;\n  padding: 0 25px;\n  border-radius: 12px;\n}\n\n.transactions_by_id_items hr{\n  margin: 0;\n  border: solid 0.5px #c1c1c1;\n}\n\n.transactions_by_id_item_box{\n  display: flex;\n  flex-direction: column;\n  padding: 25px 0;\n}\n\n.transactions_by_id_item_title{\n  font-size: 14px;\n  font-weight: 600;\n  color: #2b2b2b;\n  margin-bottom: 5px;\n}\n\n.transactions_by_id_item_content{\n  font-size: 16px;\n  font-weight: 400;\n  color: #000000;\n}\n\n.withdrawDeposit_box{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.transactions_by_id_details {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.transactions_by_id_details_wallet {\n  width: 65%;\n  display: flex;\n  flex-direction: column;\n  background-color: #F2F3FC;\n  padding: 20px;\n  border-radius: 15px;\n}\n\n.transactions_by_id_details_wallet_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.transactions_by_id_details_title {\n  margin: 0 0 20px 0;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.transactions_by_id_details_box{\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.transactions_by_id_details_p {\n  margin: 5px 0;\n}\n\n.transactions_by_id_details_item_title {\n  margin: 0;\n  font-size: 11px;\n  display: block;\n  color: #7f7f7f;\n}\n\n.transactions_by_id_details_item_desc{\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #5c5c5c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
